/**
 * The links inside rendered markdown, whose container `MarkdownRenderer` marks with
 * `data-markdown-renderer`. For a surface that acts on those links without rendering them, such as
 * a page that previews the pull requests they link to.
 */
export const MARKDOWN_RENDERER_LINK_SELECTOR = '[data-markdown-renderer] a[href]';
